<script setup lang="ts">
import { useCaseRouteParams } from "@/hooks/use-case-route-params";

withDefaults(defineProps<{ requireReason?: boolean }>(), { requireReason: true, })

const reasonValue = defineModel<string>("reason", { required: false });
const caseRefValue = defineModel<string>("caseRef", { required: true });

const routeParams = useCaseRouteParams();

const REASON_MAX_LENGTH = 4000;
const reasonID = `confirm-reason-${routeParams.value.casename}`;
const caseRefID = `confirm-case-reference-${routeParams.value.casename}`;
</script>
<template>
  <div v-if="requireReason" class="tw-flex tw-flex-col tw-gap-1">
    <label :for="reasonID" class="tw-text-xs">Reason</label>
    <textarea
      :id="reasonID"
      v-model.trim="reasonValue"
      required
      name="reason"
      class="tw-w-full tw-rounded tw-border tw-p-2 tw-text-sm [field-sizing:content]"
    />
  </div>
  <div class="tw-flex tw-flex-col tw-gap-1">
    <label :for="caseRefID" class="tw-text-xs">
      Type the case reference "
      <span class="tw-select-none tw-font-bold">{{ routeParams.casename }}</span>
      " to confirm
    </label>
    <input
      :id="caseRefID"
      v-model="caseRefValue"
      type="text"
      required
      class="tw-w-full tw-rounded tw-border tw-p-2 tw-text-sm"
      placeholder="..."
      :maxlength="REASON_MAX_LENGTH"
    />
  </div>
</template>
